// T-75: a Sessions row's own notification level, keyed like the server (session-notification-pref.ts):
// `session:<canonical DM peer id>`, "all" (default) | "muted" (shown as "No notifications").
export const SESSION_SCOPE_PREFIX = "session:";

export type SessionNotificationLevel = "all" | "muted";

export const sessionScopeId = (peerId: string): string => `${SESSION_SCOPE_PREFIX}${peerId}`;

export function isSessionSilenced(
  prefs: Readonly<Record<string, string>>,
  peerId: string,
): boolean {
  return prefs[sessionScopeId(peerId)] === "muted";
}
